import React, { useState, useEffect, useRef } from 'react'

import { usePageEditorContext } from '../../contexts/page-editor.context'
import { ReportBlock } from '../../blocks/report-block'
import { selectComponentService } from '../../../common/services/select-component.service'
import { reportDataSetService } from '../report-data-set.service'
import { DatasetFieldsEditor, DatasetEmptyState } from '../dataset-fields-editor'
import { SUBGROUP_COLUMN } from '../report-data-set.constants'
import { BlockEditButtonGroup } from '../block-edit-button-group'

const subgroupColumns = [SUBGROUP_COLUMN.PAGE_FILTER, SUBGROUP_COLUMN.PRIMARY, SUBGROUP_COLUMN.FILTERS]

export const SankeyBlockEditInline = function () {
  const pageEditorContext = usePageEditorContext() || {}
  const currentEdit = pageEditorContext.currentEdit || {}
  const block = currentEdit.block || {}
  block.props = block.props || {}

  const dataSetOptions = useRef(reportDataSetService.getDataSetOptions(pageEditorContext.page, 'sankey'))
  const [editMode, setEditMode] = useState(true)
  const [dataKeyStatus, setDataKeyStatus] = useState(getDataKeyStatus())
  const [dataFieldOptions, setDataFieldOptions] = useState(getDataFieldOptions())

  useEffect(() => {
    const dataKeyStatus = getDataKeyStatus()

    if (dataKeyStatus.isValid) {
      setDataFieldOptions(getDataFieldOptions())
    }
    setDataKeyStatus(dataKeyStatus)
  }, [block.dataKey, block.props.parentControlBar, block.props.parentBlock])

  function updateCurrentEdit (currentEdit) {
    // Ensure any updates to the block result in a new object
    if (currentEdit.block) {
      currentEdit.block = { ...currentEdit.block }
    }

    // Enables the Save button
    currentEdit.isValid = true

    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit(currentEdit)
  }

  function getDataKeyStatus () {
    return {
      isSelected: block.dataKey !== undefined,
      isValid: selectComponentService.isKnownField(dataSetOptions.current, block.dataKey)
    }
  }

  function getDataFieldOptions () {
    return reportDataSetService.getDataFieldOptions(pageEditorContext.page, block.dataKey)
  }

  function handleDataSetChange ({ value }) {
    if (block.dataKey === undefined) {
      setBlockDefaults(value)
    }

    block.dataKey = value
    updateCurrentEdit({ block })
  }

  function setBlockDefaults (selectedDataKey) {
    delete block.props.placeholder
    block.props.valueLabel = 'Patients'

    const labels = reportDataSetService.getDataSetLabels(pageEditorContext.page, selectedDataKey)
    if (labels.stages) {
      block.props.stageLabels = labels.stages
    }
    if (labels.states) {
      block.props.stateLabels = labels.states
    }
  }

  function handleDataFieldChange () {
    updateCurrentEdit({ block })
  }

  if (!dataKeyStatus.isSelected) {
    return <DatasetEmptyState block={block} dataSetOptions={dataSetOptions.current} isDatasetKeyValid={dataKeyStatus.isValid} handleDataSetChange={handleDataSetChange} />
  }

  return (
    <div className="report-editor-inline">
      <div className={editMode ? 'button-row-edit-mode' : 'button-row'}>
        {block.dataKey !== undefined && (
          <BlockEditButtonGroup isInEditMode={editMode} onModeToggle={setEditMode} canPreview={true} />
        )}
      </div>
      {editMode
        ? (
          <DatasetFieldsEditor
            block={block}
            datasetOptions={dataSetOptions.current}
            isDatasetKeyValid={dataKeyStatus.isValid}
            handleDataSetChange={handleDataSetChange}
            dataFields={[]}
            dataFieldOptions={dataFieldOptions}
            handleDataFieldChange={handleDataFieldChange}
            subgroupColumns={subgroupColumns}
            showSplitChartOption
          />
        )
        // Preview
        : (
          <ReportBlock
            blockKey={block.key}
            report={pageEditorContext.page}
            isPreviewMode={true}
            {...block}
          />
        )
      }
    </div>
  )
}
